import { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Table,
  TableBody,
  TableRow,
  TableCell,
  TableHead,
} from "@mui/material";
import { toast } from "react-toastify";
import { fetchPOD } from "../../app/services/OrdersService";
import PageWrapper from "../../app/shared/common/PageWrapper";
import CreateTable from "../../app/shared/common/table/CreateTable";
import { useNavigate } from "react-router-dom";

const tableColumns = [
  { key: "salesReturnId", label: "Return ID" },
  { key: "orderId", label: "Order ID" },
  { key: "totalAmount", label: "Total Amount" },
  { key: "deliveredBy", label: "Delivered By" },
  { key: "vehicle_number", label: "Vehicle Number" },
  { key: "createdAt", label: "Created At" },
];

const PODList = () => {
  const navigate = useNavigate();

  const [salesReturns, setSalesReturns] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  // popup state
  const [selectedItems, setSelectedItems] = useState<any[]>([]);
  const [selectedImages, setSelectedImages] = useState<any[]>([]);
  const [openDialog, setOpenDialog] = useState(false);

  const loadSalesReturns = async () => {
    try {
      setLoading(true);
      const res = await fetchPOD({});
      if (res.status === "success") {
        const mappedData = res.data.map((item: any) => ({
          id: item.id,
          salesReturnId: item.id,
          orderId: item.order?.unique_id,
          totalAmount: `₹${item.order?.total_amount}`,
          deliveredBy: item.delivered_by?.name || "—",
          vehicle_number:item.vehicle?.vehicle_number || "—",
          totalItems: {
            count: item.items?.length ?? 0,
            items: item.items ?? [],
            images: item.images ?? [], 
          },
          createdAt: new Date(item.created_at).toLocaleString(),
        }));
        setSalesReturns(mappedData);
      } else {
        toast.error(res.message);
      }
    } catch (err) {
      toast.error("Failed to load sales returns.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadSalesReturns();
  }, []);

  // handle popup
  const handleOpenItems = (value: any) => {
    setSelectedItems(value.items);
    setSelectedImages(value.images);
    setOpenDialog(true);
  };
  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedItems([]);
    setSelectedImages([]);
  };

  return (
    <PageWrapper title={"POD List"}>
      <CreateTable
        data={salesReturns}
        columns={tableColumns}
        loading={loading}
        customRender={{
          salesReturnId: (value: any, row: any) => (
            <Button
              variant="text"
              color="primary"
              onClick={() => navigate(`/orders/pod/${row.id}`)}
            >
              {value}
            </Button>
          ),
          totalItems: (value: any) => (
            <Button
              variant="text"
              size="small"
              onClick={() => handleOpenItems(value)}
            >
              {value.count}
            </Button>
          ),
        }}
      />

      {/* Items Popup */}
      <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="md" fullWidth>
        <DialogTitle>Returned Items</DialogTitle>
        <DialogContent>
          <Table>
            <TableHead>
              <TableRow>
                {/* <TableCell>Image</TableCell> */}
                <TableCell>Product Name</TableCell>
                <TableCell>SKU</TableCell>
                <TableCell>Quantity</TableCell>
                <TableCell>Reason</TableCell> 
              </TableRow>
            </TableHead>
            <TableBody>
              {selectedItems.map((it, idx) => (
                <TableRow key={it.id}>
                  {/* <TableCell>
                    {it.product?.images?.[0]?.path || selectedImages[idx]?.image ? (
                      <img
                        src={it.product?.images?.[0]?.path || selectedImages[idx]?.image}
                        alt={it.product?.name}
                        width="50"
                        height="50"
                        style={{ borderRadius: "8px", objectFit: "cover" }}
                      />
                    ) : (
                      "—"
                    )}
                  </TableCell> */}
                  <TableCell>{it.product?.name}</TableCell>
                  <TableCell>{it.product?.sku}</TableCell>
                  <TableCell>{it.quantity}</TableCell>
                  <TableCell>{it.reason?.name || "—"}</TableCell> 
                </TableRow>
              ))}
            </TableBody>
          </Table>
          {selectedItems.length > 0 && (
            <div style={{ marginTop: "20px", display: "flex", flexWrap: "wrap", gap: "10px" }}>
              {selectedItems.slice(0, 6).map((it, idx) => {
                const imgSrc = it.product?.images?.[0]?.path || selectedImages[idx]?.image;
                return imgSrc ? (
                  <img
                    key={idx}
                    src={imgSrc}
                    alt={it.product?.name}
                    width="80"
                    height="80"
                    style={{ borderRadius: "8px", objectFit: "cover" }}
                  />
                ) : null;
              })}
              {selectedItems.length > 6 && (
                <div
                  style={{
                    width: "80px",
                    height: "80px",
                    borderRadius: "8px",
                    background: "#f0f0f0",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: "bold",
                  }}
                >
                  +{selectedItems.length - 6}
                </div>
              )}
            </div>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog}>Close</Button>
        </DialogActions>
      </Dialog>
    </PageWrapper>
  );
};

export default PODList;
